/**************************************************
 * Nombre:       Seccion_Cursos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {CASILLA_ESTADO, CASILLA_FECHA_DATO} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {AttachMoney, Layers, ManageSearch, School, Toc} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Curso from "../Dialogos/Cursos/Dialogo_Curso";
import Dialogo_Curos_Valores from "../Dialogos/Cursos/Dialogo_Curos_Valores";
import Dialogo_Curos_Modulos from "../Dialogos/Cursos/Dialogo_Curos_Modulos";
import Dialogo_Curos_Profesores from "../Dialogos/Cursos/Dialogo_Curos_Profesores";
import Formulario_Curso_Iconos from "../Formularios/Cursos/Formulario_Curso_Iconos";
import Dialogo_Curso_Iconos from "../Dialogos/Cursos/Dialogo_Curso_Iconos";


const Seccion_Cursos = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'cursos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Curso,
        titulo: 'Detalles del curso',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoValores, abrir: abrirValores} = useDialogo({
        Componente: Dialogo_Curos_Valores,
        titulo: 'Valores del curso',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoModulo, abrir: abrirModulo} = useDialogo({
        Componente: Dialogo_Curos_Modulos,
        titulo: 'Modulos del curso',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoProfesores, abrir: abrirProfesores} = useDialogo({
        Componente: Dialogo_Curos_Profesores,
        titulo: 'Profesores del curso',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoIconos, abrir: abrirIconos} = useDialogo({
        Componente: Dialogo_Curso_Iconos,
        titulo: 'Iconos del curso',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'valores':
                abrirValores(data)
                break
            case 'modulos':
                abrirModulo(data)
                break
            case 'profesores':
                abrirProfesores(data)
                break
            case 'iconos':
                abrirIconos(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoValores/>

                <DialogoModulo/>

                <DialogoProfesores/>

               <DialogoIconos/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de cursos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Cursos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Fecha Inicio',
        direccion: 'left',
        propiedad: 'certifiquese',
        fecha: 'fechaIncio',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSUSUARIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Valores',
        id: 'valores',
        icono: AttachMoney
    },
    {
        nombre: 'Modulos',
        id: 'modulos',
        icono: Layers
    },
    {
        nombre: 'Profesores',
        id: 'profesores',
        icono: School
    },
    {
        nombre: 'Iconos',
        id: 'iconos',
        icono: Toc
    },
]